import { dispatcher } from 'store';

export const inverters = {
  setInverterIdx(index) {
    return function (dispatch) {
      dispatch(dispatcher('UPDATE_SERVICE_MODULE', { currentInverterIdx: index }));
    };
  },
};